import React from "react";
import { Check } from "lucide-react";

// Petits contrôles du menu Affichage, partagés avec la vue des chauffeurs.
export function SwitchItem({ checked, hint, label, onChange, option }) {
  return (
    <button type="button" role="menuitemcheckbox" aria-checked={checked} tabIndex={-1} data-keep-menu-open
      data-dispatch-display-option={option} className="dispatch-header-menu-action" onClick={() => onChange(option, !checked)}>
      <span className="min-w-0 flex-1 flex-col items-start! gap-0!">
        <span className="font-bold text-content-ink">{label}</span>
        {hint ? <span className="text-[0.72rem] font-normal text-slate-700">{hint}</span> : null}
      </span>
      <span aria-hidden="true" className={`inline-flex h-5 w-9 shrink-0 items-center rounded-full border p-0.5 transition-colors ${checked ? "border-legacy-teal bg-legacy-teal" : "border-slate-300 bg-slate-200"}`}>
        <span className={`h-3.5 w-3.5 rounded-full bg-white shadow-sm transition-transform ${checked ? "translate-x-4" : "translate-x-0"}`} />
      </span>
    </button>
  );
}

export function Chip({ checked, disabled = false, label, onClick, option, value }) {
  return (
    <button type="button" role="menuitemcheckbox" aria-checked={checked} tabIndex={-1} data-keep-menu-open data-dispatch-display-option={option}
      data-dispatch-display-value={value} disabled={disabled} onClick={onClick}
      className={`inline-flex h-6 items-center gap-1 rounded-[4px] border px-2 text-[0.72rem] font-extrabold ${checked ? "border-accent bg-accent text-white" : "border-slate-300 bg-white text-slate-600 hover:bg-slate-50"}`}>
      {checked ? <Check className="h-3 w-3" strokeWidth={3} /> : null}{label}
    </button>
  );
}

export const CheckBox = ({ checked, className = "" }) => (
  <span aria-hidden="true" className={`grid h-4 w-4 shrink-0 place-items-center items-center justify-center rounded-[3px] border-[1.5px] text-white ${checked ? "border-accent bg-accent" : "border-slate-400 bg-white"} ${className}`}>
    {checked ? <Check className="h-2.5! w-2.5!" strokeWidth={3.5} /> : null}
  </span>
);
